import React, {FC} from "react";
import {
    IDamsList,
    ITag,
    ITagEntry,
    IInvestigation,
    IDataTest,
    dataEntry, ISocietalRisk
} from "../../types/types";
import {Accordion, AccordionSummary, Grid, Paper, Tooltip} from "@material-ui/core";
import {ExpandMore} from "@material-ui/icons";
import Typography from "@material-ui/core/Typography";
import NoDamInfo from "./no_dam";
import BarLargeChart from "./bar_large";
import HeatmapInvestigation from "./heat_map_table_investigation";


interface ICHProps {
    damList: IDamsList[],
    risk_assessments: ISocietalRisk[],
    assessments_filtered: number[],
    investigations: IInvestigation[],
    tags: ITag[],
    tag_entries: ITagEntry[]
}


const InvestigationSummary: FC<ICHProps> = ({
                                                investigations,
                                                risk_assessments,
                                                tags,
                                                tag_entries,
                                                damList,
                                                assessments_filtered
                                            }) => {

    const filtered_investigations: Array<IInvestigation> = [];
    //
    assessments_filtered.forEach(id => {
        const filtered = investigations.filter(s => s.assessment_project_id === id)
        filtered.forEach(element => filtered_investigations.push(element))
    })


    const filtered_tags: Array<ITag> = [];
    tags.forEach(tag => {
        if (tag.name !== 'Operational Risk Assessment') {
            if (tag.name !== 'Physical Investigations') {
                filtered_tags.push(tag)
            }
        }})  


    //
    let anyDams = false
    if (assessments_filtered.length > 0) {
        anyDams = true
    }
    // plot a pie chart of the likelihood for each dam
    const investigations_bar = (): IDataTest<dataEntry> => {

        const data = tags.filter(tag => {
            const n_invs = tag_entries.filter(i => i.tag_uuid == tag.uuid && filtered_investigations.filter(fi => fi.uuid == i.entry_uuid).length > 0).length
            return n_invs > 0
        }).map(tag => {
            const n_invs = tag_entries.filter(i => i.tag_uuid == tag.uuid && filtered_investigations.filter(fi => fi.uuid == i.entry_uuid).length > 0).length
            return {
                name: tag.name,
                value: [n_invs]
            }
        }).sort(
            (a, b) => a.value[0] - b.value[0]
        )
        return {
            title: 'Total number of investigations by Category',
            description: data.map(d => d.name),
            data: data,
            colour: {
                background: [],
                font: []
            },
            height: 600,
            axis_label: {x: "Number of investigations", y: ""}
        }
    }

    // Sort tags by number of investigations.
    // const sorted_tags = tags.filter(tag => {
    //     const n_invs = tag_entries.filter(i => i.tag_uuid == tag.uuid && filtered_investigations.filter(fi => fi.uuid == i.entry_uuid).length > 0).length
    //     return n_invs > 0
    // }).map(tag => {
    //     const n_invs = tag_entries.filter(i => i.tag_uuid == tag.uuid && filtered_investigations.filter(fi => fi.uuid == i.entry_uuid).length > 0).length
    //     return {
    //         tag: tag,
    //         value: [n_invs]
    //     }
    // }).sort(
    //     (a, b) => b.value[0] - a.value[0]
    // ).map(
    //     (d) => d.tag
    // )

    const sorted_tags = tags
    // console.log('sorted tags', sorted_tags)

    const dam_investigations: any[][] = assessments_filtered.map(a_id => {
        const ress = []
        // const filtered = assessments_filtered.filter(i => i. === dam.id)
        ress.push(damList.find(d => d.id === a_id)?.dam.name)
        let soc_level: any = risk_assessments.filter(dam => dam.assessment_project_id === a_id)

        // there is the potential for a dam to not have any data
        let societal_risk_value: number | string = 0
        if (soc_level.length > 0) {
            let societal_risk_value_number = soc_level[0].societal_risk_before
            societal_risk_value = societal_risk_value_number.toExponential(2)

        }
        ress.push(societal_risk_value)

        let total = 0

        sorted_tags.map(tag => {
            
            
            // load investigations for each dam assessment
            const invs = filtered_investigations.filter(i => i.assessment_project_id === a_id)

            const n_invs = tag_entries.filter(
                i => i.tag_uuid == tag.uuid && invs.filter(fi => fi.uuid == i.entry_uuid).length > 0).length
            if (n_invs > 0) {
                ress.push([4 - n_invs, n_invs])
                total += n_invs
            } else {
                if (tag.name !== 'Operational Risk Assessment') {
                    if (tag.name !== 'Physical Investigations') {
                        ress.push([0, ""])
                    }    
            }}
        })
        ress.push([0, total])
        // console.log(ress)
        return ress

    })

    //sort data by societal impact
    dam_investigations.sort((a, b) => {
        return b[1] - a[1]
    })

    dam_investigations.forEach(d => {
        if (d[1] === 0) {
            d[1] = 'Undefined'
        }
    })

    // console.log('this data', dam_investigations)




    // plot a pie chart of the likelihood for each dam
    const investigation_per_dam_bar = (): IDataTest<dataEntry> => {

        const data = tags.map(tag => {
            const invs = tag_entries.filter(i => i.tag_uuid == tag.uuid && filtered_investigations.filter(fi => fi.uuid == i.entry_uuid).length > 0)

            // count unique assessment_project_ids in invs
            const assessment_project_ids = invs.filter(
                (i) => {
                    const inv = investigations.find(fi => fi.uuid == i.entry_uuid)
                    if (inv)
                        return true
                    return false
                }).map(
                (i) => {
                    const inv = investigations.find(fi => fi.uuid == i.entry_uuid)
                    if (inv)
                        if (inv.assessment_project_id)
                            return inv.assessment_project_id
                    return 0
                })
            const unique_assessment_project_ids = new Set(assessment_project_ids);
            const n_invs = unique_assessment_project_ids.size

            return {
                name: tag.name,
                value: [n_invs]
            }
        }).filter(a => a.value[0] > 0).sort(
            (a, b) => a.value[0] - b.value[0]
        )

        return {
            title: 'Investigations across dams',
            description: data.map(d => d.name),
            data: data,
            colour: {
                background: [],
                font: []
            },
            height: 600,
            axis_label: {x: "Number of dams", y: ""}
        }
    }

   


    return (

        <>
            <Accordion>
                <AccordionSummary id={"1"} expandIcon={<ExpandMore/>}>
                    <Typography variant="h6"> Summary </Typography>
                </AccordionSummary>
                <Typography>
                    <div style={{padding: "10px"}}>
                        <Paper variant={"outlined"} style={{
                            textAlign: 'left',
                            height: '50px',
                            display: 'flex',
                            alignItems: 'center',
                            padding: '10px'
                        }}>

                            The first graph shows the number of dams to which an investigation theme is applicable. The second graph shows the total number of investigations across the dams selected in the filter.
                        </Paper>
                    </div>
                    <Grid container spacing={3} xl={12} direction="row">
                        {(<>
                            <Grid item xs={12} sm={12} md={12} lg={6}>
                                {anyDams
                                    ? <BarLargeChart data={investigation_per_dam_bar()}/>
                                    : <NoDamInfo/>}
                            </Grid>
                            <Grid item xs={12} sm={12} md={12} lg={6}>
                                {anyDams
                                    ? <BarLargeChart data={investigations_bar()}/>
                                    : <NoDamInfo/>}
                            </Grid>

                        </>)}
                    </Grid>
                </Typography>
            </Accordion>
            <Accordion>
                <AccordionSummary id={"1"} expandIcon={<ExpandMore/>}>
                    <Typography variant="h6"> Detail </Typography>
                </AccordionSummary>
                <Typography>
                    <Paper variant={"outlined"} style={{textAlign: 'left', padding: '10px'}}>

                    </Paper>
                    <Grid container spacing={3} xl={12} direction="row">
                        {(<>

                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    {anyDams
                                        ? <HeatmapInvestigation investigations={dam_investigations} tags={filtered_tags}/>
                                        : <NoDamInfo/>}

                                </Grid>
                            </>
                        )}

                    </Grid>
                </Typography>
            </Accordion>
        </>
    )

}


export default InvestigationSummary;